<template>
  <v-content>
    <div class="view-container">
      <div
        v-if="$route.name !== 'Maps' && $route.meta.fullpage !== true"
        id="core-view"
      >
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </div>
      <div v-if="$route.name === 'Maps' || $route.meta.fullpage === true">
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </div>
      <div v-if="$route.name !== 'Maps' && $route.meta.fullpage !== true">
        <v-layout align-center justify-center>
          <core-footer />
        </v-layout>
      </div>
    </div>
  </v-content>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "SUPER - Juntos Energia Compartilhada",
    };
  },
};
</script>

<style scoped>
#core-view {
  padding-bottom: 0px;
}
.view-container {
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  height: 100% !important;
  max-width: 100% !important;
}
</style>
